import server from '../../../server'

class PartTransactionController {
  constructor($state, $confirm, selectPartModal, server, ObjectDetailService) {
    this.$state = $state
    this.$confirm = $confirm
    this.selectPartModal = selectPartModal
    this.server = server
    this.objectDetailService = ObjectDetailService
  }

  $onInit() {
    if (!this.partTransaction || !this.partTransaction.Results) {
      return
    }
  
    this.partTransaction.Results.forEach(tran => {
      tran._detailsLoaded = false
      tran._loading = false
      tran.isItemsCollapsed = true
  
      const items = Array.isArray(tran.PartTransactionItems)
        ? tran.PartTransactionItems
        : Object.values(tran.PartTransactionItems || {})
  
      items.forEach(item => {
        let contextObj = {}
  
        if (item.Context) {
          try {
            const parsed =
              typeof item.Context === 'string'
                ? JSON.parse(item.Context)
                : item.Context
  
            contextObj = this.normalizeContext(parsed)
          } catch (e) {
            console.error('Invalid Context JSON', item.Context)
          }
        }
  
        item.ContextObj = contextObj
        item.objectIdentifier = this.buildObjectIdentifier(item)
      })
  
      tran.negativeItems = items.filter(x => x.QuantityChange < 0)
      tran.positiveItems = items.filter(x => x.QuantityChange > 0)
    })
  }
  

  toggleItems(tran) {
    tran.isItemsCollapsed = !tran.isItemsCollapsed
  
    if (tran.isItemsCollapsed) {
      return
    }
    if (tran._detailsLoaded) {
      return
    }
  
    const identifiers = [
      ...tran.negativeItems,
      ...tran.positiveItems
    ]
      .map(item => item.objectIdentifier)
      .filter(Boolean)
  
    if (!identifiers.length) {
      console.warn('No identifiers found', tran)
      tran._detailsLoaded = true
      return
    }
  
    tran._loading = true
  
    this.objectDetailService
      .fetchObjects(identifiers)
      .then(results => {
        results.forEach(r => {
          [...tran.negativeItems, ...tran.positiveItems].forEach(item => {
            if (
              item.objectIdentifier &&
              item.objectIdentifier.type === r.identifier.type &&
              item.objectIdentifier.id === r.identifier.id
            ) {
              item.objectDetail = r.object
            }
          })
        })
      })
      .finally(() => {
        tran._detailsLoaded = true
        tran._loading = false
      })
  }
  

  buildObjectIdentifier(item) {
    const ctx = item.ContextObj || {}

    switch (item.TableName) {
      case 'PartOrderItem':
        return ctx.PartOrderItemId
          ? { type: 'PartOrderItem', id: ctx.PartOrderItemId }
          : null

      case 'PartLocation':
        return ctx.PartPropertyId
          ? { type: 'PartLocation', id: ctx.PartPropertyId }
          : null

      case 'MachinePart':
        return ctx.MachineId
          ? { type: 'MachinePart', id: ctx.MachineId }
          : null

      case 'CheckedOutPart':
        return ctx.CheckedOutById
          ? { type: 'CheckedOutPart', id: ctx.CheckedOutById }
          : null

      case 'VoidPartLocation':
        return ctx.VoidPartLocationId
          ? { type: 'VoidPartLocation', id: ctx.VoidPartLocationId }
          : null

      default:
        return null
    }
  }

  normalizeContext(ctx) {
    const clean = {}

    if (!ctx || typeof ctx !== 'object') {
      return clean
    }

    Object.keys(ctx).forEach(key => {
      const cleanKey = key.replace(/^"+|"+$/g, '')
      let value = ctx[key]

      if (typeof value === 'string') {
        value = value.replace(/^"+|"+$/g, '')
      }

      clean[cleanKey] = value
    })

    return clean
  }
}

PartTransactionController.$inject = [
  '$state',
  '$confirm',
  'selectPartModal',
  server.vsName,
  'ObjectDetailService'
]

export default PartTransactionController
